import { isNativeFieldApp } from './installPrompt';

export const cameraPermissionMessage = (err) => {
  const text = String(err?.message || err || '');
  if (/cancel/i.test(text)) return '';
  if (/permission|denied|restrict/i.test(text)) {
    return 'Samsung: Settings → Apps → LGL Portal → Permissions → Camera. Allow it, then tap Camera again.';
  }
  return 'Could not open the camera. Try Gallery, or allow Camera for LGL Portal.';
};

const fileFromWebPath = async (webPath, name = `field-${Date.now()}.jpg`) => {
  const response = await fetch(webPath);
  const blob = await response.blob();
  const type = blob.type || 'image/jpeg';
  const ext = type.includes('png') ? '.png' : '.jpg';
  return new File([blob], name.replace(/\.\w+$/, ext), { type });
};

/**
 * Camera stays in-page (`via: 'live'`) so Android does not reload the WebView
 * and dump the walk back to login. Gallery still uses Photos on the APK.
 */
export const pickFieldPhoto = async (kind = 'camera') => {
  if (kind !== 'gallery') return { via: 'live' };
  if (!isNativeFieldApp()) return { via: 'input' };
  try {
    const { Camera, CameraResultType, CameraSource } = await import('@capacitor/camera');
    const photo = await Camera.getPhoto({
      quality: 80,
      resultType: CameraResultType.Uri,
      source: CameraSource.Photos,
      saveToGallery: false,
      correctOrientation: true,
    });
    if (!photo?.webPath) return { error: 'Could not read that photo.' };
    return { file: await fileFromWebPath(photo.webPath) };
  } catch (err) {
    const message = cameraPermissionMessage(err);
    if (!message) return { via: 'cancel' };
    return { error: message };
  }
};
